<template>
  <div>
    <v-dialog v-model="AttachBox.showing" persistent ligth max-width="700">
      <v-card>
        <v-btn icon absolute top right small @click="AttachBox.showing = false">
          <v-icon> mdi-close </v-icon>
        </v-btn>
        <v-row justify="center" no-gutters>
          <v-icon large> mdi-attachments : </v-icon>
          <v-card-title class="headline">
            {{ $t("messanger.chat.send_attachment") }} :
          </v-card-title>
        </v-row>
        <v-card-text class="text-center mt-3">
          <v-row justify="center" dense>
            <v-col v-if="files.length" cols="12" sm="12">
              <v-card
                width="100%"
                max-height="150"
                outlined
                class="scroll-box-attach pa-0"
              >
                <v-row
                  :justify="files.length === 1 ? 'center' : 'start'"
                  align="center"
                >
                  <v-col
                    cols="4"
                    sm="2"
                    v-for="(img, index) in files"
                    :key="index"
                  >
                    <v-hover v-slot="{ hover }">
                      <v-img :src="img.url" width="100%" aspect-ratio=".85">
                        <template v-slot>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                            v-if="hover"
                          >
                            <v-btn
                              dark
                              absolute
                              fab
                              x-small
                              @click="remove_image(index)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-row>
                        </template>
                      </v-img>
                    </v-hover>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12">
              <v-form
                v-model="valid"
                @submit.prevent="onButtonClick"
                enctype="multipart/form-data"
              >
                <template>
                  <v-file-input
                    v-model="files"
                    :rules="rulesImages"
                    accept="image/png, image/jpeg, image/bmp"
                    type="file"
                    color="cleed_blue accent-4"
                    counter
                    label="File input"
                    multiple
                    placeholder="Select your files"
                    prepend-icon="mdi-paperclip"
                    outlined
                    :show-size="1000"
                    @change="uploadFile"
                  >
                    <template v-slot:selection="{ index, text }">
                      <v-chip
                        v-if="index < 2"
                        color="cleed_blue accent-4"
                        dark
                        label
                        small
                      >
                        {{ text }}
                      </v-chip>

                      <span
                        v-else-if="index === 2"
                        class="text-overline grey--text text--darken-3 mx-2"
                      >
                        +{{ files.length - 2 }} File(s)
                      </span>
                    </template>
                  </v-file-input>
                </template>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row justify="center" dense>
            <v-col cols="auto">
              <v-btn
                :disabled="!valid"
                color="black"
                :dark="valid"
                @click="handleSubmit"
                :loading="loading"
              >
                <v-icon class="ml-0 mr-1">mdi-telegram</v-icon>
                <strong>{{ $t("messanger.chat.send_text") }}</strong>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "box_attachment",
  data() {
    return {
      valid: false,
      loading: false,
      isSelecting: false,
      hover: false,
      files: [],
      rulesImages: [
        (value) => {
          if (value && value.length) {
            return true;
          }
          return "field is required";
        },
        (value) => {
          if (value) {
            if (!value.length) {
              return "field is required";
            }
            if (value.length > 4) {
              return "Limit files to upload is 4";
            }
            for (let i = 0; i < value.length; i++) {
              const element = value[i];
              if (element.size >= 2000000) {
                return `${element.name} images size should be less than 2 MB!`;
              }
            }
            return true;
          }
          return false;
        },
      ],
    };
  },
  computed: {
    AttachBox() {
      return this.$store.state.AttachBox;
    },
  },
  methods: {
    remove_image(index) {
      this.files.splice(index, 1);
    },
    async uploadFile(event) {
      for (let i = 0; i < this.files.length; i++) {
        const element = this.files[i];
        this.files[i].url = URL.createObjectURL(element);
      }
    },
    handleSubmit() {
      const formData = new FormData();
      for (let i = 0; i < this.files.length; i++) {
        const element = this.files[i];
        formData.append("uploadedImages", element);
      }
      formData.append("guid", this.$store.state.chat_user.guid);
      formData.append("conversation_id", this.$store.state.chat_user.guid);
      this.loading = true;
      this.$store
        .dispatch("SEND_ATTACHMENTS", {
          formData,
          guid: this.$store.state.chat_user.guid,
        })
        .then(() => {
          this.files = [];
          this.AttachBox.showing = false;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.files = [];
          console.log(err.data);
          this.$store.dispatch("setSnackbar", {
            text: `Fail to send attachments`,
            color: "error",
            timeout: 2000,
          });
        });
    },
  },
};
</script>
<style scoped>
.scroll-box-attach {
  scroll-behavior: smooth;
  overflow: hidden auto;
}
</style>
